import * as React from "react";
const Gray = (props) => (
    <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="77" height="77" rx="38.5" fill="#F5F5F5"/>
    <rect x="0.5" y="0.5" width="77" height="77" rx="38.5" stroke="black"/>
    <path d="M45.4989 34.117L37.442 42.3241L34.5011 39.2972C34.3479 39.1723 34.1028 39.1723 33.9803 39.2972L33.0919 40.2021C32.9694 40.327 32.9694 40.5766 33.0919 40.7326L37.1969 44.883C37.3501 45.039 37.5646 45.039 37.7177 44.883L46.9081 35.5213C47.0306 35.3965 47.0306 35.1468 46.9081 34.9908L46.0197 34.117C45.8972 33.961 45.6521 33.961 45.4989 34.117Z" fill="#444444"/>
    </svg>
    
);
export default Gray;
